app.controller('popupHospitalAndSanatoriumCreateController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'patientModel', 'hospitalAndSanatoriumModel', 'fileUploadModel',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel, hospitalAndSanatoriumModel, fileUploadModel) {

        function checkAllFilesLoaded() {
            function check(element) {
                return (element.loaded == true);
            }

            return $scope.fileList.every(check);
        }

        function saveHospitalAndSanatorium () {
            $scope.hospitalAndSanatorium.icd10s = [$scope.icd10];
            hospitalAndSanatoriumModel.save($scope.hospitalAndSanatorium);
            $scope.actionInProgress = true;

            var successWatcherDisabler = $scope.$on(Event.HOSPITAL_AND_SANATORIUM.SAVE.SUCCESS, function (event, result) {
                successWatcherDisabler();
                errorWatcherDisabler();
                $mdDialog.hide();
                $scope.actionInProgress = false;
            });
            var errorWatcherDisabler = $scope.$on(Event.HOSPITAL_AND_SANATORIUM.SAVE.ERROR, function (event, error) {
                successWatcherDisabler();
                errorWatcherDisabler();
                $scope.actionInProgress = false;
            });
        }

        function setData() {
            $scope.hospitalAndSanatorium = new HospitalAndSanatoriumVO();
            $scope.hospitalAndSanatorium.patient = new PatientVO();
            $scope.hospitalAndSanatorium.patient.id = $state.params.patientId;
            $scope.hospitalAndSanatorium.attachments = [];

            $scope.hospitalAndSanatorium.doctor = new DoctorVO();
            $scope.hospitalAndSanatorium.doctor.id = userModel.getCurrentContextDoctorId();

            $scope.forms = {
                hospitalAndSanatoriumForm: null
            };

            $scope.hospitalAndSanatoriumActionType = 'save';

            $scope.fileList = [];
            $scope.presentDate = new Date();

            $scope.icd10 = null;
            $scope.actionInProgress = false;
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.save = function () {

                $scope.forms.hospitalAndSanatoriumForm.$setSubmitted();
                if ($scope.forms.hospitalAndSanatoriumForm.$valid) {
                    $scope.actionInProgress = true;

                    $scope.fileList.forEach(function (file) {
                        fileUploadModel.uploadFile(file);
                    });

                    if(checkAllFilesLoaded()) {
                        saveHospitalAndSanatorium();
                    }

                    $scope.$on(Event.FILE_UPLOAD.UPLOAD_FILE.SUCCESS, function (event, attachmentFile, file) {
                        file.loaded = true;

                        var attachment = new AttachmentVO();

                        if(!attachment.attachmentFiles) {
                            attachment.attachmentFiles = [];
                        }
                        attachment.name = attachmentFile.fileName;
                        attachment.attachmentFiles.push(attachmentFile);

                        $scope.hospitalAndSanatorium.attachments.push(attachment);

                        if(checkAllFilesLoaded()) {
                            saveHospitalAndSanatorium();
                        }

                    });
                }
            };

            $scope.enclose = function (fileInput) {
                if(fileInput.length > 0) {
                    fileInput.forEach(function(element) {
                        $scope.fileList.push({ loaded: false, data: element})
                    });
                }
            };

            $scope.deleteAttachment = function(fileToDelete) {
                if(fileToDelete.attachmentFile) {
                    _.remove($scope.hospitalAndSanatorium.attachments, function (attachmentFile) {
                        return attachmentFile.attachmentFiles[0] === fileToDelete.attachmentFile;
                    })
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);